import { Field, InputType } from 'type-graphql'
import type { IAction } from '../../action/IAction'
import { ActionArgs } from '../../action'
import type { Blog } from '../Blog'

/**
 * Input arguments for cancelling blog transcription job mutation
 */
@InputType()
export class CancelBlogTranscriptionJobArgs extends ActionArgs {
  @Field()
  blogId!: string
}

export interface ICancelBlogTranscriptionJob extends IAction<Blog, CancelBlogTranscriptionJobArgs> {}
